import { commonThemeData, defaultPalette, themeTypography } from './themeData';
export const defaultTheme = {
    ...themeTypography,
    ...defaultPalette,
    ...commonThemeData,
};
